import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import { Option } from 'types/select';
import { translate } from 'utils';
import { isOtherOptionSelected } from 'utils/ultraPrescription.utils';

import RhfCheckboxGroup from './CheckboxGroup/RhfCheckboxGroup/RhfCheckboxGroup';
import { FormLabel } from './FormLabel/FormLabel';
import { RHFTextArea } from './RHFTextArea/RHFTextArea';

interface Props {
  title: string;
  animateLabel: string;
  checkBoxGroupName: string;
  otherTextBoxName: string;
  options: Option[];
  isDisabled?: boolean;
  checkBoxItemFontClass?: string;
}
const CheckboxGroupWithOtherTextBox: FC<Props> = ({
  isDisabled,
  checkBoxGroupName,
  otherTextBoxName,
  title,
  animateLabel,
  options,
  checkBoxItemFontClass = 'md:text-17px text-sm grid grid-cols-5'
}) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchCheckBoxGroup = watch(checkBoxGroupName);
  const fieldError =
    _.get(errors, checkBoxGroupName) || _.get(errors, otherTextBoxName);
  return (
    <div className='flex flex-col '>
      <FormLabel
        label={translate(title)}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={animateLabel}
      />
      <RhfCheckboxGroup
        disabled={isDisabled}
        options={options}
        name={checkBoxGroupName}
        className='mt-1'
        checkBoxItemFont={checkBoxItemFontClass}
        labelClassName='mr-14'
      />
      {isOtherOptionSelected(watchCheckBoxGroup) && (
        <RHFTextArea
          name={otherTextBoxName}
          autogrow
          inputProps={{
            placeholder: translate('settings.please_type_here'),
            disabled: isDisabled
          }}
          className=''
          maxgrowHeight={260}
        />
      )}
    </div>
  );
};
export default CheckboxGroupWithOtherTextBox;
